<template>
  <RecycleScroller
    class="scroller image-memo-body"
    direction="horizontal"
    :items="allImageMemos"
    :item-size="imgSize"
    :minItemSize="imgSize"
    key-field="id"
    v-slot="{ item }"
  >
    <div class="imagememo__item">
      <div class="frame">
        <img :src="item.url" @click.prevent="onClickImage(item.id)" />
        <span v-if="deletable && !item.isFreeHand" @click.prevent="deleteImage(item.id)">
          <CloseIcon class="delete" />
        </span>
      </div>
    </div>
  </RecycleScroller>
</template>

<script>
import { RecycleScroller } from '@/components/molecules/VirtualScroller'
import CloseIcon from '@/components/icons/close'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'ImageMemo',
  components: {
    RecycleScroller,
    CloseIcon,
  },
  props: {
    deletable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      imgSize: 136,
    }
  },
  computed: {
    ...mapState({
      isSP: state => state.app.isSP,
      imageMemos: 'imageMemos',
    }),
    ...mapGetters({
      allImageMemos: 'imageMemos/all',
    }),
  },
  mounted() {
    this.imgSize = this.isSP ? 138 : 192
  },
  methods: {
    onClickImage(id) {
      this.$emit('select', id)
    },
    deleteImage(id) {
      this.$emit('delete', id)
    },
  },
}
</script>

<style lang="postcss" scoped>
.scroller {
  height: 152px;
  width: 100%;
}

.imagememo__item {
  display: flex;
  padding: 24px 0 8px;
}

.frame {
  background-color: var(--white);
  border: 1px solid var(--light-gray);
  border-radius: 4px;
  filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.3));
  height: 100%;
  padding: 3px;
  position: relative;
  width: 100%;
}

img {
  height: 112px;
  object-fit: cover;
  width: 168px;
}

.delete {
  background: var(--pure-red);
  border-radius: 50%;
  box-sizing: border-box;
  cursor: pointer;
  fill: var(--white);
  height: 32px;
  padding: 2px;
  position: absolute;
  right: -14px;
  top: -14px;
  width: 32px;
}

.sp {
  .scroller {
    height: 136px;
  }

  .imagememo__item {
    padding: 24px 0;
  }

  .frame {
    padding: 2px;
  }

  img {
    height: 82px;
    width: 122px;
  }

  .delete {
    height: 24px;
    right: -8px;
    top: -8px;
    width: 24px;
  }
}
</style>
